import React, { useMemo } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { lightScrollbarStyle } from "../../../../../styles/lightScrollbarStyle";
import { useCompanyPageStore } from "../../../../../store/companyPageStore";
import { CompanyMapChart } from "./CompanyMapChart";

export const CompanyDescription: React.FC = React.memo(() => {
  const company = useCompanyPageStore((state) => state.company);

  const latitude = company?.latitude;
  const longitude = company?.longitude;
  const hasLocation = latitude && longitude;
  const hasDescription = (company?.description?.length || 0) > 0;

  const scrollbarStyles = useMemo(
    () => ({ ...lightScrollbarStyle, overflowY: "auto" }),
    []
  );

  if (!company) return null;

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight="bold" sx={{ mb: 3 }}>
        Company Description
      </Typography>
      {hasDescription && (
        <Box maxHeight="200px" paddingRight={2} sx={scrollbarStyles}>
          <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
            {company.description}
          </Typography>
        </Box>
      )}

      {/* Map Chart */}
      {hasLocation ? (
        <CompanyMapChart
          latitude={latitude}
          longitude={longitude}
          companyName={company.name}
        />
      ) : (
        <></>
      )}
    </Box>
  );
});

CompanyDescription.displayName = "CompanyDescription";
